export type CMDBRegisterPageTabView = 'info' | 'bond' | 'logs' | 'attachment' | 'digitalTerm' | 'inconsistencies';
export const allowedCMDBRegisterPageTabViews: CMDBRegisterPageTabView[] = [
	'info',
	'bond',
	'logs',
	'attachment',
	'digitalTerm',
	'inconsistencies',
];
